import { render, staticRenderFns } from "./StatusDropdown.vue?vue&type=template&id=cc8fc9be&"
import script from "./StatusDropdown.vue?vue&type=script&lang=js&"
export * from "./StatusDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc8fc9be')) {
      api.createRecord('cc8fc9be', component.options)
    } else {
      api.reload('cc8fc9be', component.options)
    }
    module.hot.accept("./StatusDropdown.vue?vue&type=template&id=cc8fc9be&", function () {
      api.rerender('cc8fc9be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/StatusDropdown.vue"
export default component.exports